import { FormControl, FormLabel, InputAdornment, IconButton, TextField } from '@mui/material';
import { useState } from 'react';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const Field = ({ label, wAuto, ...props }) => {
    return (
        <FormControl fullWidth={!wAuto}>
            {label && <FormLabel sx={{ fontWeight: 600, mb: 0.6 }}>{label}</FormLabel>}
            <TextField {...props} size="small" />
        </FormControl>
    );
};



const PasswordField = ({ label, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <FormControl>
            <FormLabel sx={{ fontWeight: 600, mb: 0.6 }}>{label}</FormLabel>
            <TextField
                size="small"
                type={showPassword ? 'text' : 'password'}
                {...props}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton type="button" onClick={() => setShowPassword(!showPassword)} color="secondary">
                                {!showPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </FormControl>
    );
};
export { PasswordField };

export default Field;
